import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';
import { Shield, X } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function CookieConsent() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const consent = localStorage.getItem('euromoto_cookie_consent');
      if (!consent) setVisible(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const accept = () => {
    localStorage.setItem('euromoto_cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('euromoto_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 pb-16 sm:pb-4" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-[#141B2D] border border-[#1E293B] rounded-xl p-5 shadow-2xl shadow-black/40 backdrop-blur-xl">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg bg-[#0A3A82]/20 flex items-center justify-center shrink-0 mt-0.5">
            <Shield className="w-5 h-5 text-[#FADB5F]" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-[#F1F5F9] mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Cookie Policy
            </h3>
            <p className="text-xs text-[#94A3B8] leading-relaxed mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
              We use essential cookies to keep you logged in and remember your language preferences. 
              We do not use tracking or advertising cookies. By continuing to use EuroMoto, you agree to our{' '}
              <Link to="/privacy" className="text-[#FADB5F] hover:underline">Privacy Policy</Link>{' '}
              and{' '}
              <Link to="/terms" className="text-[#FADB5F] hover:underline">Terms of Service</Link>.
            </p>
            <div className="flex items-center gap-2">
              <Button onClick={accept} size="sm" className="bg-[#FADB5F] text-[#0F172A] hover:bg-[#E5C34A] font-semibold text-xs px-4" data-testid="cookie-accept-btn">
                Accept
              </Button>
              <Button onClick={decline} variant="ghost" size="sm" className="text-[#94A3B8] hover:text-[#F1F5F9] text-xs" data-testid="cookie-decline-btn">
                Essential Only
              </Button>
            </div>
          </div>
          <button onClick={decline} className="text-[#475569] hover:text-[#94A3B8] transition-colors shrink-0" data-testid="cookie-close-btn">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
